import { cn } from '@/lib/utils/tw-merge';
import type { VehicleAvailability } from './vehicle.types';

const STATE_CLASSES: Record<VehicleAvailability['state'], string> = {
    available: 'availability--available',
    reserved: 'availability--reserved',
    fromDate: 'availability--from-date',
};

/** Dot plus text — the colour never carries the state alone (WCAG 1.4.1). */
export function VehicleAvailabilityLabel({
    availability,
    className,
}: {
    availability: VehicleAvailability;
    className?: string;
}) {
    return (
        <span className={cn('availability', STATE_CLASSES[availability.state], className)}>
            <span className="availability__label">{availability.label}</span>
        </span>
    );
}
